import React from "react";
import { Link } from "react-router-dom";
import Window from "../components/Window";
import Icon, { IconName, IconTile } from "../components/Icon";

const features: {
  icon: IconName;
  tone: "pink" | "blue" | "gold" | "green" | "violet";
  title: string;
  text: string;
}[] = [
  {
    icon: "pin",
    tone: "blue",
    title: "Pin a letter to the board",
    text: "Post about yourself and the pen pal you're hoping for, even anonymously.",
  },
  {
    icon: "mail",
    tone: "pink",
    title: "Slow letters, real friendships",
    text: "Once someone accepts your request, you write each other letters. No feeds, no likes, no rush.",
  },
  {
    icon: "shield",
    tone: "violet",
    title: "Safety built in",
    text: "Letters are only between pen pals. Block anyone, report anything, and a real person reads every report.",
  },
  {
    icon: "heart",
    tone: "green",
    title: "Made for us",
    text: "Centered on trans, Two-Spirit, queer, disabled, and QTBIPOC folks. Share your flags, your pace, and how many spoons you have today.",
  },
];

export default function Welcome() {
  return (
    <>
      <Window title="welcome.htm" tone="pink" minimizable={false}>
        <h1 className="window-heading text-3xl">
          A pen pal network for 2SLGBTQIA+ folks ✿
        </h1>
        <p className="mb-4 text-lg">
          PenPal Board is a cozy, adults-only (18+) corner of the internet for
          trans, Two-Spirit, queer, and disabled people to find pen pals and
          write real letters to each other. Queer and trans Black, Indigenous,
          and people of color: this space is especially for you.
        </p>
        <div className="btn-row">
          <Link to="/signup" className="btn">
            <Icon name="heart" size={16} /> Join the network
          </Link>
          <Link to="/signin" className="btn btn-plain">
            I already have an account
          </Link>
        </div>
      </Window>

      <div className="grid gap-4 sm:grid-cols-2">
        {features.map((f) => (
          <div key={f.title} className="profile-box">
            <div className="profile-box-body flex gap-3">
              <IconTile name={f.icon} tone={f.tone} size={44} />
              <div>
                <h2 className="font-display text-lg font-semibold">{f.title}</h2>
                <p className="text-sm">{f.text}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <Window title="before_you_join.txt" tone="tan" minimizable={false}>
        <p className="text-sm">
          It's free, there are no ads, and your data is never sold. Have a read
          of our <Link to="/guidelines">community guidelines</Link> and{" "}
          <Link to="/privacy">privacy page</Link>. By joining, you agree to
          treat each other with care.
        </p>
      </Window>
    </>
  );
}
